module.exports = __webpack_public_path__ + "static/111247447_s-3a6d44fc6dd01a8a928cfda85af0197f.png";